import styles from "./splashGlowPreview.module.scss";

/** Превью сплэша: свои стили (копия), чтобы крутить цвета/blur без изменения splashScreen */
export function SplashGlowPreviewPage() {
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.dimmingLayer} aria-hidden />
        <div className={styles.gradient} aria-hidden />
        <div className={styles.gradient} aria-hidden />
        <div className={styles.gradient} aria-hidden />
        <div className={styles.gradient} aria-hidden />
      </div>
    </div>
  );
}
